import { InferValuesTypes } from '@yandex-int/k-common/typings';

import { POPUP_AXIS, GRAVITIES, OffsetValue } from '../constants';

import * as actions from './actions';

export enum HINT_KIND {
    CALL_TO_ACTION = 'call-to-action',
    INFO = 'info',
    MODAL = 'modal',
}

export enum LINK_COMPONENTS {
    TEXT = 'text',
    BUTTON = 'button',
}

export interface Hint {
    id: string;
    title?: string;
    xpath: string;
    kind: HINT_KIND;
    withExplicitClose?: boolean;
    closeOnTargetClick?: boolean;
    shouldBlockScroll?: boolean;
    description?: string;
    link?: {
        title: string;
        component: LINK_COMPONENTS;
    };
    axis?: POPUP_AXIS;
    gravity?: GRAVITIES;
    offset?: {
        top?: OffsetValue;
        left?: OffsetValue;
    };
    targetAreaOffset?: {
        top?: OffsetValue;
        left?: OffsetValue;
    };
    countViews?: boolean;
    includedVariables?: Record<string, string>;
}

export interface HintStore {
    config: Array<Hint> | null;
    matchedHints: Array<Hint>;
}

export type HintAction = ReturnType<InferValuesTypes<typeof actions>>;

export interface HintInnerData {
    viewedDate: string;
    isTargetClicked?: boolean;
    viewedCount?: number;
}

export type HintData = Record<string, HintInnerData>;
